module.exports = __webpack_public_path__ + "media/images/bnr_special_onsen-2b4dc9bcc56293bdec7af110b0fe996a.jpg";